import { render, staticRenderFns } from "./checkResultDialog.vue?vue&type=template&id=540df9dc&scoped=true"
import script from "./checkResultDialog.vue?vue&type=script&lang=js"
export * from "./checkResultDialog.vue?vue&type=script&lang=js"
import style0 from "./checkResultDialog.vue?vue&type=style&index=0&id=540df9dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540df9dc",
  null
  
)

export default component.exports